var map = {
	"./10import-23.xlsx": "./src/shared/assets/template/10import-23.xlsx",
	"./10import-24.xlsx": "./src/shared/assets/template/10import-24.xlsx",
	"./11import-25.xlsx": "./src/shared/assets/template/11import-25.xlsx",
	"./11import-26.xlsx": "./src/shared/assets/template/11import-26.xlsx",
	"./11import-27.xlsx": "./src/shared/assets/template/11import-27.xlsx",
	"./12import-28.xlsx": "./src/shared/assets/template/12import-28.xlsx",
	"./12import.xlsx": "./src/shared/assets/template/12import.xlsx",
	"./13import-29.xlsx": "./src/shared/assets/template/13import-29.xlsx",
	"./13import-30.xlsx": "./src/shared/assets/template/13import-30.xlsx",
	"./13import-31.xlsx": "./src/shared/assets/template/13import-31.xlsx",
	"./13import-32.xlsx": "./src/shared/assets/template/13import-32.xlsx",
	"./15import-34.xlsx": "./src/shared/assets/template/15import-34.xlsx",
	"./15import.xlsx": "./src/shared/assets/template/15import.xlsx",
	"./16import-35.xlsx": "./src/shared/assets/template/16import-35.xlsx",
	"./16import.xlsx": "./src/shared/assets/template/16import.xlsx",
	"./17import-36.xlsx": "./src/shared/assets/template/17import-36.xlsx",
	"./17import-37.xlsx": "./src/shared/assets/template/17import-37.xlsx",
	"./17import-38.xlsx": "./src/shared/assets/template/17import-38.xlsx",
	"./17import-39.xlsx": "./src/shared/assets/template/17import-39.xlsx",
	"./18import-40.xlsx": "./src/shared/assets/template/18import-40.xlsx",
	"./18import-41.xlsx": "./src/shared/assets/template/18import-41.xlsx",
	"./18import-42.xlsx": "./src/shared/assets/template/18import-42.xlsx",
	"./18import-43.xlsx": "./src/shared/assets/template/18import-43.xlsx",
	"./18import-44.xlsx": "./src/shared/assets/template/18import-44.xlsx",
	"./19import-45-old.xlsx": "./src/shared/assets/template/19import-45-old.xlsx",
	"./19import-45.xlsx": "./src/shared/assets/template/19import-45.xlsx",
	"./1import-1.xlsx": "./src/shared/assets/template/1import-1.xlsx",
	"./1import-2.xlsx": "./src/shared/assets/template/1import-2.xlsx",
	"./1import-3.xlsx": "./src/shared/assets/template/1import-3.xlsx",
	"./20import-46.xlsx": "./src/shared/assets/template/20import-46.xlsx",
	"./21import-47.xlsx": "./src/shared/assets/template/21import-47.xlsx",
	"./21import.xlsx": "./src/shared/assets/template/21import.xlsx",
	"./22import-48.xlsx": "./src/shared/assets/template/22import-48.xlsx",
	"./22import-49.xlsx": "./src/shared/assets/template/22import-49.xlsx",
	"./23import-50.xlsx": "./src/shared/assets/template/23import-50.xlsx",
	"./23import-51.xlsx": "./src/shared/assets/template/23import-51.xlsx",
	"./23import-52.xlsx": "./src/shared/assets/template/23import-52.xlsx",
	"./24import-53.xlsx": "./src/shared/assets/template/24import-53.xlsx",
	"./25import-54.xlsx": "./src/shared/assets/template/25import-54.xlsx",
	"./25import.xlsx": "./src/shared/assets/template/25import.xlsx",
	"./26import-55.xlsx": "./src/shared/assets/template/26import-55.xlsx",
	"./26import-56.xlsx": "./src/shared/assets/template/26import-56.xlsx",
	"./27import-57.xlsx": "./src/shared/assets/template/27import-57.xlsx",
	"./27import-58.xlsx": "./src/shared/assets/template/27import-58.xlsx",
	"./28import-59.xlsx": "./src/shared/assets/template/28import-59.xlsx",
	"./28import.xlsx": "./src/shared/assets/template/28import.xlsx",
	"./29import-60.xlsx": "./src/shared/assets/template/29import-60.xlsx",
	"./29import.xlsx": "./src/shared/assets/template/29import.xlsx",
	"./2import-4.xlsx": "./src/shared/assets/template/2import-4.xlsx",
	"./30import-61.xlsx": "./src/shared/assets/template/30import-61.xlsx",
	"./30import.xlsx": "./src/shared/assets/template/30import.xlsx",
	"./31import-62.xlsx": "./src/shared/assets/template/31import-62.xlsx",
	"./31import-63.xlsx": "./src/shared/assets/template/31import-63.xlsx",
	"./32import-64.xlsx": "./src/shared/assets/template/32import-64.xlsx",
	"./32import-65.xlsx": "./src/shared/assets/template/32import-65.xlsx",
	"./33import-66.xlsx": "./src/shared/assets/template/33import-66.xlsx",
	"./33import-67.xlsx": "./src/shared/assets/template/33import-67.xlsx",
	"./34import-68.xlsx": "./src/shared/assets/template/34import-68.xlsx",
	"./35import-69.xlsx": "./src/shared/assets/template/35import-69.xlsx",
	"./35import.xlsx": "./src/shared/assets/template/35import.xlsx",
	"./36Import.xlsx": "./src/shared/assets/template/36Import.xlsx",
	"./36import-70.xlsx": "./src/shared/assets/template/36import-70.xlsx",
	"./37import-71.xlsx": "./src/shared/assets/template/37import-71.xlsx",
	"./37import-72.xlsx": "./src/shared/assets/template/37import-72.xlsx",
	"./38import-73.xlsx": "./src/shared/assets/template/38import-73.xlsx",
	"./38import.xlsx": "./src/shared/assets/template/38import.xlsx",
	"./39import-74.xlsx": "./src/shared/assets/template/39import-74.xlsx",
	"./39import.xlsx": "./src/shared/assets/template/39import.xlsx",
	"./42import-75.xlsx": "./src/shared/assets/template/42import-75.xlsx",
	"./42import-76.xlsx": "./src/shared/assets/template/42import-76.xlsx",
	"./43import-77.xlsx": "./src/shared/assets/template/43import-77.xlsx",
	"./43import.xlsx": "./src/shared/assets/template/43import.xlsx",
	"./44import-84.xlsx": "./src/shared/assets/template/44import-84.xlsx",
	"./44import.xlsx": "./src/shared/assets/template/44import.xlsx",
	"./5import-10.xlsx": "./src/shared/assets/template/5import-10.xlsx",
	"./5import-5.xlsx": "./src/shared/assets/template/5import-5.xlsx",
	"./5import-6.xlsx": "./src/shared/assets/template/5import-6.xlsx",
	"./5import-7.xlsx": "./src/shared/assets/template/5import-7.xlsx",
	"./5import-8.xlsx": "./src/shared/assets/template/5import-8.xlsx",
	"./5import-9.xlsx": "./src/shared/assets/template/5import-9.xlsx",
	"./6import-11.xlsx": "./src/shared/assets/template/6import-11.xlsx",
	"./6import.xlsx": "./src/shared/assets/template/6import.xlsx",
	"./7import-12.xlsx": "./src/shared/assets/template/7import-12.xlsx",
	"./7import-13.xlsx": "./src/shared/assets/template/7import-13.xlsx",
	"./7import-14.xlsx": "./src/shared/assets/template/7import-14.xlsx",
	"./8import-15.xlsx": "./src/shared/assets/template/8import-15.xlsx",
	"./8import-16.xlsx": "./src/shared/assets/template/8import-16.xlsx",
	"./8import-17.xlsx": "./src/shared/assets/template/8import-17.xlsx",
	"./8import-18.xlsx": "./src/shared/assets/template/8import-18.xlsx",
	"./8import-19.xlsx": "./src/shared/assets/template/8import-19.xlsx",
	"./8import-20.xlsx": "./src/shared/assets/template/8import-20.xlsx",
	"./9import-21.xlsx": "./src/shared/assets/template/9import-21.xlsx",
	"./9import.xlsx": "./src/shared/assets/template/9import.xlsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/shared/assets/template sync recursive ^\\.\\/.*\\.xlsx$";